widgetEvents = {
    init() {dd('EVENTS_INIT');
        $(document).on('widget:search', this.onSearch.bind(this));
        $(document).on('widget:detail', this.onDetail.bind(this));
        $(document).on('widget:list', this.onList.bind(this));
    },

    // Поиск выполнен
    onSearch(event) {
        this.toggleElements('search');
        console.log('Параметры поиска:', event.detail);
    },

    // Переход на детальную страницу
    onDetail(event) {
        this.toggleElements('detail');
        console.log('Данные тура:', event.detail);
    },

    // Возврат к списку
    onList(event) {
        this.toggleElements('list');
        console.log('Возврат:', event.detail);
    },

    // Показать / скрыть элементы
    toggleElements(eventName) {
        $('[data-widget-hide="' + eventName + '"]').hide();
        $('[data-widget-show="' + eventName + '"]').show();
        $('[data-widget-toggle="' + eventName + '"]').toggle();
    },
};



$(document).init(function() {
    widgetEvents.init();
});